
export default {
  name: 'VsSvgIcon',
  inheritAttrs: false,
  props: {
    path: {
      type: String,
      default: null
    },
    size: {
      type: [Number, String],
      default: 24
    }
  },
  computed: {
    viewBox() {
      return `0 0 ${this.size} ${this.size}`
    }
  }
}
